import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CreateBooking from '../CreateBooking';
import PortalMachines from '../PortalMachines';
import MachineDetail from '../MachineDetail';
import PortalBookings from '../PortalBookings';
import BookingDetail from '../BookingDetail';
import PortalLocks from '../PortalLocks';
import CreateLock from '../CreateLock';

import getAllRequest from '../../Redux/Actions/getall';
import reloadPageRequest from '../../Redux/Actions/reload';
import getAllMachineRequest from '../../Redux/Actions/machine';

const menuAdmin = [
  {
    id: 0,
    name: 'Machines',
    link: '/admin/machines',
    icon: 'server',
  },
  {
    id: 1,
    name: 'Bookings',
    link: '/admin/bookings',
    icon: 'id-badge',
  },
  {
    id: 3,
    name: 'Locks',
    link: '/admin/locks',
    icon: 'archive',
  },
];

class Full extends Component {
  componentDidMount = () => {
    this.startTimerStatus();

    window.onbeforeunload = () => {
      this.props.reloadPageRequest();
    };

    window.onload = () => {
      this.props.getAllRequest();
    };
  }

  componentWillUnmount = () => {
    clearInterval(this.timerStatus);
  }

  startTimerStatus = () => {
    if (!this.timerStatus) {
      this.timerStatus = setInterval(() => {
        this.props.getAllMachineRequest();
      }, 60 * 1000);
    }
  }

  sendCommand = async (
    commandMessage,
  ) => {
    // [START iot_send_command]
    // const cloudRegion = 'us-central1';
    // const deviceId = 'my-device';
    // const commandMessage = 'message for device';
    // const projectId = 'adjective-noun-123';
    // const registryId = 'my-registry';
    const iotClient = new iot.v1.DeviceManagerClient({
      // optional auth parameters.
    });

    const formattedName = iotClient.devicePath(
      projectId,
      cloudRegion,
      registryId,
      deviceId,
    );
    const binaryData = Buffer.from(commandMessage);
    const request = {
      name: formattedName,
      binaryData,
    };

    try {
      const responses = await iotClient.sendCommandToDevice(request);

      console.log('Sent command: ', responses[0]);
    } catch (err) {
      console.error('Could not send command:', err);
    }
  };

  render = () => (
    <div className="app">
      <Header userName="admin" />
      <div id="app-body" className="app-body">
        <Sidebar menu={menuAdmin} />
        <Switch>
          <Route exact path="/admin/machines" name="portal-machines" component={PortalMachines} />
          <Route path="/admin/machines/:serialMachine" name="detail-machine" component={MachineDetail} />
          <Route exact path="/admin/bookings" name="portal-bookings" component={PortalBookings} />
          <Route path="/admin/bookings/new/:bookingId" name="detail-new" component={BookingDetail} />
          <Route path="/admin/bookings/checkedin/:bookingId" name="detail-checkin" component={BookingDetail} />
          <Route path="/admin/bookings/done/:bookingId" name="detail-checkout" component={BookingDetail} />
          <Route path="/admin/createbooking" name="create-booking" component={CreateBooking} />
          <Route path="/admin/locks" name="locks" component={PortalLocks} />
          <Route path="/admin/createlock" name="create-lock" component={CreateLock} />
          <Redirect from="/" to="/admin/machines" />
        </Switch>
      </div>
      <Footer />
    </div>
  )
}

Full.propTypes = {
  reloadPageRequest: PropTypes.func.isRequired,
  getAllRequest: PropTypes.func.isRequired,
  getAllMachineRequest: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  reloadPageRequest,
  getAllRequest,
  getAllMachineRequest,
};

export default connect(null, mapDispatchToProps)(Full);
